import React, { forwardRef } from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../lib/utils'

const variants = {
  // Rider Page (Light Mode Paper)
  rider: 'texture-paper text-ink border-2 border-[#B8A890] tape-top bg-[#F2E8D5]',
  
  // Flight Case (Dark Mode Road Case)
  flightcase: 'texture-roadcase text-white border-4 border-panel rivets bg-[#2A2A2A]',
  
  // Cardboard (Mid-tone)
  cardboard: 'texture-cardboard text-ink border-2 border-[#B8A890] bg-[#D8C8B0]',
  
  // Vinyl Record (Leaderboard)
  vinyl: 'vinyl-record text-white',
}

const Card = forwardRef(({ 
  children, 
  className,
  variant = 'flightcase',
  rotate = false,
  glow = false,
  tape = false,
  ...props 
}, ref) => {
  const cardClasses = cn(
    // Base card styling
    'relative rounded-lg p-6',
    'effect-creased',
    
    // Variant-specific
    variants[variant],
    
    // Optional effects
    rotate && 'transform rotate-[-0.3deg]',
    glow && 'shadow-neon',
    tape && !variants[variant].includes('tape') && 'tape-top',
    
    // Override padding for headers
    (className?.includes('concert-ticket-header') || className?.includes('page-header-simple')) && 'p-0',
    
    className
  )

  // Inline style fallbacks for critical visual elements
  const inlineStyles = variant === 'rider' ? {
    backgroundColor: '#F2E8D5',
    background: '#F2E8D5',
    backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'100\' height=\'100\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' /%3E%3C/filter%3E%3Crect width=\'100\' height=\'100\' filter=\'url(%23noise)\' opacity=\'0.4\'/%3E%3C/svg%3E")',
  } : variant === 'flightcase' ? {
    backgroundColor: '#2A2A2A',
    background: '#2A2A2A',
    backgroundImage: 'repeating-linear-gradient(45deg, #2A2A2A 0px, #2A2A2A 20px, #2C2C2C 20px, #2C2C2C 22px)',
  } : {}

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={cardClasses}
      style={{ ...inlineStyles, ...props.style }}
      {...props}
    >
      {children}
    </motion.div>
  )
})

Card.displayName = 'Card'

export default Card
